import { render, staticRenderFns } from "./ultimasCompras.vue?vue&type=template&id=36eb5b98&scoped=true&"
import script from "./ultimasCompras.vue?vue&type=script&lang=js&"
export * from "./ultimasCompras.vue?vue&type=script&lang=js&"
import style0 from "./ultimasCompras.vue?vue&type=style&index=0&id=36eb5b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eb5b98",
  null
  
)

export default component.exports